import React, { useEffect } from 'react';
import { StudioError } from '../../../services/error-service';
import DialogModal from '../../utils/DialogModal';


const FatalErrorDialog = ({ open, error }: { open: boolean, error: StudioError }) => {

    return (
        <DialogModal open={open} onClose={() => { window.location.href = process.env.REACT_APP_ROUTING_BASE_URL || process.env.PUBLIC_URL; }} iconClass={"exclam"} buttonOk={"QUIT"}>
            <>
                <p>
                    {error?.message}
                </p>
            </>
        </DialogModal>
    )
}

export default FatalErrorDialog;
